import { createFileRoute } from "@tanstack/react-router";
import { useOrg } from "~/contexts/org-context";
import { PeoplePage } from "~/pages/org/people-page";

export const Route = createFileRoute("/org/$org/people")({
  validateSearch: (search: Record<string, unknown>) => ({
    view: search.view === "pending" ? ("pending" as const) : ("active" as const),
    q: typeof search.q === "string" ? search.q : undefined,
  }),
  component: OrgPeoplePage,
});

function OrgPeoplePage() {
  const org = useOrg();

  if (!org.activeOrg) {
    return <div className="p-4">Loading...</div>;
  }

  return <PeoplePage organization={org.activeOrg} />;
}
